import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckOutlined } from "sprout-ui-icons";
import { visuallyHiddenStyle } from "sprout-ui-dom/dist/utils";
import { Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled, { css } from "styled-components";
const PostMultiselectLabel = styled(Flex)`
  flex: none;

  margin: -12px 0 -12px -12px;
  ${media.up("medium")} {
    margin: -10px 0 -10px -10px;
  }

  ${media.up("medium", "pointer")} {
    opacity: ${({ $isMultiselectActive  })=>$isMultiselectActive ? 1 : 0};
    margin: 0;
    position: absolute;
    top: -10px;
    left: -48px;

    :hover {
      opacity: 1;
    }
  }

  width: 48px;
  height: 48px;
  ${media.up("medium")} {
    width: 44px;
    height: 44px;
  }
  cursor: pointer;
  pointer-events: auto;

  ${({ $disabled  })=>$disabled && css`
      cursor: not-allowed;
      pointer-events: none;
    `}
`;
const PostMultiselect = (props)=>{
    const { navigationItemHelpers , disabled: disabledProp  } = props;
    const { isSelected , isSelectable , isMultiselectActive , toggleMultiselect  } = navigationItemHelpers;
    const disabled = disabledProp || !isSelectable;
    if (disabled) return null;
    return /*#__PURE__*/ _jsxs(PostMultiselectLabel, {
        as: "label",
        $disabled: disabled,
        $isMultiselectActive: isMultiselectActive,
        children: [
            /*#__PURE__*/ _jsx("input", {
                disabled: disabled,
                type: "checkbox",
                style: visuallyHiddenStyle,
                onChange: toggleMultiselect,
                /* This is needed for the scenario where the user clicks the multiselect
        but chooses to use the keyboard for actions */ className: "mousetrap"
            }),
            /*#__PURE__*/ _jsx(Flex, {
                m: "auto",
                as: "span",
                alignItems: "center",
                justifyContent: "center",
                width: "24px",
                height: "24px",
                borderWidth: isMultiselectActive ? "2px" : "1px",
                borderStyle: "solid",
                borderColor: isMultiselectActive ? "blue.500" : "black.40",
                borderRadius: "3px",
                bg: isSelected ? "blue.500" : undefined,
                color: isSelected ? "white.100" : undefined,
                children: isSelected && /*#__PURE__*/ _jsx(CheckOutlined, {})
            })
        ]
    });
};
export default PostMultiselect;
